import { ITagResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { TagRequest } from '../../../TagRequest';

import { IAnalyticsExtSiteSettings } from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';

export type IUpdateAnalyticsExtSiteSettingsResult = ITagResult & IAnalyticsExtSiteSettings;

export class UpdateAnalyticsExtSiteSettingsRequest extends TagRequest<IAnalyticsExtSiteSettings, IUpdateAnalyticsExtSiteSettingsResult> {
  constructor(params: IAnalyticsExtSiteSettings) {
    super('analyticsextensions', 'updateAnalyticsExtensionsSiteSettings', params);
  }
}
